import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";


export class MaxCapOutroController extends FreespinOutroController {
    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super(config, tweakEnabled);
    }

    protected calculateIsTriggered(data:TombstoneParsedGameData):boolean {
      return data.brokeTheBank;
    }

    protected doTransitions() {
    }

    protected close() {
        super.close();
    }
}